import React from 'react';
import './SideBar.css';
import { AiFillLock } from "react-icons/ai";
import cslogo from '../../assets/logo_cs.png';
import { RxHamburgerMenu } from "react-icons/rx";
import { RiHome4Line } from "react-icons/ri";
import { AiOutlineDashboard } from "react-icons/ai";
import { BiSolidMegaphone } from "react-icons/bi";
import { PiTelegramLogoLight } from "react-icons/pi";
import { RiTwitterXFill } from "react-icons/ri";
import { RiContractLine } from "react-icons/ri";
import { LuShieldCheck } from "react-icons/lu";
import { ImLaptop } from "react-icons/im";
import { LuBlocks } from "react-icons/lu";
import { RiMegaphoneLine } from "react-icons/ri";
import { HiOutlineDocumentText } from "react-icons/hi2";
import { TbHelpSquare } from "react-icons/tb";
import { NavLink } from 'react-router-dom';
import { MdClose } from "react-icons/md";
import { MdOutlineMedicalServices } from "react-icons/md";

const Suitcase = MdOutlineMedicalServices  as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
const Contract = RiContractLine  as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
const Dash = AiOutlineDashboard as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
const Ad = RiMegaphoneLine as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
const TG = PiTelegramLogoLight  as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
const X = RiTwitterXFill  as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
const Audit = LuShieldCheck  as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
const Website = ImLaptop  as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
const Blocks = LuBlocks  as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
const Docs = HiOutlineDocumentText  as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
const Help = TbHelpSquare  as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
const Close = MdClose  as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
const Home = RiHome4Line  as unknown as React.FC<React.SVGProps<SVGSVGElement>>;

const SideBar: React.FC = () => {
    const path = window.location.pathname;

  const sideBarClose = () => {
    const sidebar = document.querySelector<HTMLElement>('.sidebar-left');
    if (sidebar) {
      sidebar.style.display = 'none';
    }
  };

  return (
    <div className="sidebar-wrap">
      <div className="sidebar-top">
      <div className="logo-hamb-side">
            <a className='sidebar-logo-box' href="/overview">
                <img className='logo-cs' src={cslogo}></img>
                <h3 className='logo-title'>Coinsult</h3>
            </a>
            <div className="closebutton" onClick={sideBarClose}>
              <Close />
            </div> 
        </div>
        <div className="sidebar-menu-items">
        <a href='https://coinsult.net'>
          <div
            className={
              'sidebar-menu-item' + (path === '/' ? ' active' : '')
            }
          >
            <Home /> Home
          </div>
        </a>
        <a href='/overview'>
          <div
            className={
              'sidebar-menu-item' + (path === '/overview' ? ' active' : '')
            }
          >
            <Dash /> Overview
          </div>
        </a>
          <a href='/advertise' target='_blank' className="sidebar-menu-item">
            <Ad /> Advertise
          </a>
        </div>
        <div className="small-type-side">
          Services
        </div>
        <div className="sidebar-menu-items">
          <a href="https://coinsult.gitbook.io/coinsult/services/development-create/smart-contract-development"  target='_blank' className="sidebar-menu-item">
            <Contract /> Contract
          </a>
          <a href="https://coinsult.gitbook.io/coinsult/services/smart-contract-audit" target='_blank'  className="sidebar-menu-item">
            <Audit /> Audit
          </a>
          <a href="https://coinsult.gitbook.io/coinsult/services/development-create/website-development"  target='_blank' className="sidebar-menu-item">
            <Website /> Website
          </a>
          <a href="https://coinsult.gitbook.io/coinsult/services/development-create" target='_blank'  className="sidebar-menu-item">
            <Blocks /> Dev
          </a>
          <a href="https://coinsult.gitbook.io/coinsult/services/all-services" target='_blank'  className="sidebar-menu-item">
            <Suitcase /> Services
          </a>
        </div>

        <div className="small-type-side">
          Resources
        </div>
        <div className="sidebar-menu-items">
          <a href='https://coinsult.gitbook.io/coinsult' target='_blank'  className="sidebar-menu-item">
            <Docs /> Docs
          </a>
          <a href='https://t.me/coinsult' target='_blank' className="sidebar-menu-item">
            <Help /> Help
          </a>
        </div>
      </div>
      <div className="sidebar-bottom">
        <a href='https://t.me/coinsult_tg' target='_blank' className="footer-button">
          Request Audit
        </a>
        <div className="socials-bottom-footer">
          <a href='https://x.com/coinsultaudits' target='_blank'><X /></a> <a href='https://t.me/coinsult' target='_blank'><TG /></a>
        </div>
      </div>
    </div>
  );
};

export default SideBar;
